import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  question: string;
  answer: string;
}
export function Accordion({
  question,
  answer
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-navy-900/10 bg-mist-100 rounded-xl overflow-hidden" data-id="element-236" data-mp="2oa14xj3a581i">
      <button onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-3 p-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-237" data-mp="3bzvg7w7yaojn">
        <span className="font-heading font-semibold text-[14.5px] sm:text-base text-navy-950 leading-tight" data-id="element-238" data-mp="337tiw6t6hodl">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-gold-hover" data-id="element-239" data-mp="3uzhp0bld5enz">
          <ChevronDown size={19} data-id="element-240" data-mp="31wi4hp2spgb4" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-241" data-mp="2wy6v1fgex7tf">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-242" data-mp="2wzi49usmn7rx">
            <div className="px-4 pb-4 pt-3 text-[13px] sm:text-sm text-navy-800/75 leading-relaxed border-t border-navy-900/10 mt-1" data-id="element-243" data-mp="3ulp3ep65w7ww">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}